import { Box, ButtonProps } from '@mantine/core';
import { IconSheet } from 'ui/Icons';

import { ButtonMantine } from '../../../../Buttons';
import { ThemeIcon } from '../../../../DataDisplay';
import { Center, Stack } from '../../../../Layout';
import { Text } from '../../../../Typography';
import classes from './NoTableData.module.css';

type NoTableDataProps = {
  text?: string;
  title?: string;
  description?:
    | ((emphasize: (text: string) => React.ReactNode) => React.ReactNode)
    | React.ReactNode;
  hasSearch?: boolean;
  icon?: React.ReactNode;
  cta?: React.ReactNode;
  buttonProps?: ButtonProps & { children: React.ReactNode; onClick?: () => void };
};

const NoSearchDataMessage = ({ hasSearch, text }: { hasSearch: boolean; text?: string }) => {
  if (!hasSearch) {
    return null;
  }

  return (
    <>
      <ThemeIcon variant="transparent" size={32} className={classes.NoTableData_icon}>
        <IconSheet size={32} />
      </ThemeIcon>
      <Text fw={600}>{`Sorry! ${text ?? 'No results found'}`}</Text>
      <Text fz="sm" c="gray" className={classes.NoTableData_description}>
        Try adjusting your search to display the data you&apos;re looking for.
      </Text>
    </>
  );
};

const NoTableData = ({
  text,
  title,
  description,
  hasSearch,
  icon,
  cta,
  buttonProps,
}: NoTableDataProps) => {
  return (
    <Center m="auto" mih={300}>
      <Stack gap="xs" align="center">
        {hasSearch ? (
          <NoSearchDataMessage hasSearch={hasSearch} text={text} />
        ) : (
          <>
            <ThemeIcon variant="transparent" size={32} className={classes.NoTableData_icon}>
              {icon ?? <IconSheet size={32} />}
            </ThemeIcon>
            <Text fw={600}>{title ? title : `Sorry! ${text ?? 'No results found'}`}</Text>
            {!!description && (
              <Text className={classes.NoTableData_description}>
                {typeof description === 'function'
                  ? description((textToEmphasize) => (
                      <Text span className={classes.NoTableData_description_emphasized}>
                        {textToEmphasize}
                      </Text>
                    ))
                  : description}
              </Text>
            )}
            {cta ? (
              <Box mt={4}>{cta}</Box>
            ) : buttonProps ? (
              <ButtonMantine size="md" mt={4} {...buttonProps}>
                {buttonProps.children}
              </ButtonMantine>
            ) : null}
          </>
        )}
      </Stack>
    </Center>
  );
};

export { NoTableData };
